import { WHATSAPP_MANAGER_TEMPLATES_URL } from "@/lib/agent-tasks/whatsapp-manager"
import { useTranslations } from "next-intl"
import { ManageTemplatesButton } from "@/components/whatsapp-templates/manage-templates-button"
import { ExternalLink } from "lucide-react"

export function WhatsappTemplateCreationGuide({ channelId }: { channelId?: string }) {
  const tUi = useTranslations("AgentTasks.AgentTasksWhatsappTemplateCreationGuide")
  const t = useTranslations("WhatsappTemplates")

  return (
    <div className="space-y-2 text-sm leading-relaxed">
      <p className="font-medium"><span>{t("templateOptionsTitle")}</span></p>
      <ol className="list-decimal space-y-2 pl-5">
      {channelId ? <li><span>{t.rich("editorOption", { editor: chunks => <ManageTemplatesButton channelId={channelId}>{chunks}</ManageTemplatesButton> })}</span></li> : null}
      <li>
      <span>{t.rich("managerOption", { manager: chunks => <a className="inline-flex items-center gap-1 text-blue-600 underline-offset-4 hover:underline" href={WHATSAPP_MANAGER_TEMPLATES_URL} target="_blank" rel="noopener noreferrer"><span>{chunks}</span><ExternalLink aria-hidden="true" className="h-3.5 w-3.5" /></a> })}</span>
      <details className="mt-2">
        <summary className="cursor-pointer text-muted-foreground"><span key={tUi("howToCreateAWhatsAppTemplate")}>{tUi("howToCreateAWhatsAppTemplate")}</span></summary>
        <ol className="mt-2 list-decimal space-y-2 pl-5">
          <li><span key={tUi("openWhatsAppManagerAndSelectTheConnectedWhatsApp")}>{tUi("openWhatsAppManagerAndSelectTheConnectedWhatsApp")}</span></li>
          <li><span key={tUi("openMessageTemplatesAndCreateATemplateChoose")}>{tUi("openMessageTemplatesAndCreateATemplateChoose")}</span></li>
          <li><span key={tUi("writeTheMessageTextAndAddExamplesFor")}>{tUi("writeTheMessageTextAndAddExamplesFor")}</span></li>
          <li><span key={tUi("afterApprovalReturnHereAndRefreshTemplatesUnavailable")}>{tUi("afterApprovalReturnHereAndRefreshTemplatesUnavailable")}</span></li>
        </ol>
        <p className="mt-2"><span key={tUi("createTemplatesInWhatsAppManagerNotTheWhatsApp")}>{tUi("createTemplatesInWhatsAppManagerNotTheWhatsApp")}</span></p>
      </details>
      </li>
      </ol>
    </div>
  )
}
